import * as yup from 'yup';
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import { TaskDefinitionStatus, TaskDefinitionGroup } from './types';

const t = i18n.getFixedT(getLocale(), 'common');

const typeSchema = yup
  .mixed<TaskDefinitionGroup>()
  .oneOf(Object.values(TaskDefinitionGroup));

const statusSchema = yup
  .mixed<TaskDefinitionStatus>()
  .oneOf(Object.values(TaskDefinitionStatus));

export const schema = yup.object().shape({
  type: yup
    .object()
    .shape({
      label: typeSchema.transform((value) => t(value)),
      value: typeSchema
    })
    .default({ label: TaskDefinitionGroup.ALL, value: TaskDefinitionGroup.ALL })
    .required(),
  status: yup
    .object()
    .shape({
      label: statusSchema.transform((value) => t(value)),
      value: statusSchema
    })
    .default({
      label: TaskDefinitionStatus.OPEN,
      value: TaskDefinitionStatus.OPEN
    })
    .required()
});
